import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  employeeId?: string;
}

const useUnlockEmployeeMfaQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.post(API_URL.MFA_UNLOCK, {
      employee_id: payload?.employeeId,
    })
  );

  return {
    unlockEmployeeMfa: mutateAsync,
    isLoading,
  };
};

export default useUnlockEmployeeMfaQuery;
